module.exports = __webpack_public_path__ + "static/media/trailer.40680268.svg";